/**
 * @generated SignedSource<<e31ba45688eb4e8629ac33b2708fcd33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionRelatedSectionContentfulRelayFragment$data = ReadonlyArray<{
  readonly sys: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"collectionCardContentfulRelayFragment">;
  readonly " $fragmentType": "collectionRelatedSectionContentfulRelayFragment";
}>;
export type collectionRelatedSectionContentfulRelayFragment$key = ReadonlyArray<{
  readonly " $data"?: collectionRelatedSectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionRelatedSectionContentfulRelayFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "collectionRelatedSectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sys",
      "kind": "LinkedField",
      "name": "sys",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "collectionCardContentfulRelayFragment"
    }
  ],
  "type": "TemplateCollection",
  "abstractKey": null
};

(node as any).hash = "c7fa5bba8ccaa025e0048f8a3ee9d86d";

export default node;
